// @flow

import SuggestionsBuilder from './SuggestionsBuilder';
import Product from '../../Product';
import Collection from '../../Collection';

export default class ProductSuggestions extends SuggestionsBuilder {
  #productTemplate: HTMLElement;

  /**
   * Create new product suggestions
   */
  constructor(suggestions: Array<any>, dataLayerSuggestions: Collection<Object>, productTemplate: HTMLElement) {
    super(suggestions, dataLayerSuggestions);
    this.#productTemplate = productTemplate.cloneNode(true);
  }

  /**
   * @inheritDoc
   */
  static hasValidData(data: any): boolean {
    return Array.isArray(data) && data.length;
  }

  /**
   * @inheritDoc
   */
  template(): string {
    const ga4Data: string = encodeURIComponent(JSON.stringify(
      this.dataLayerSuggestions.map((suggestion: Object) => ({
        item_id: suggestion.id,
        item_name: suggestion.name,
        category: suggestion.category,
        brand: suggestion.brand,
        price: suggestion.price,
        list: suggestion.list,
        quantity: 1
      })).all()
    ));
    const eventData: string = encodeURIComponent(JSON.stringify({ products: this.dataLayerSuggestions.all() }));

    return `
      <span class="block text-xs text-grey px-4 mt-4 mb-2">
        ${window.store.getTranslation('Product suggestions')}
      </span>

      <div>
        <ul
          data-component="event-notifier"
          data-on="${encodeURIComponent(JSON.stringify({ view: 'view-products' }))}"
          data-event-data="${ga4Data}"
          data-delay="500"
          data-ga4="true"
        >
          ${this.buildSuggestions()}
        </ul>
      </div>

    `;
  }

  /**
   * @inheritDoc
   */
  suggestion(suggestion: any): string {
    return `
      <li class="product__suggestion">
        ${this.buildProduct(suggestion)}
      </li>
    `;
  }

  /**
   * Build a single product suggestion
   */
  buildProduct(data: Object): string {
    const product: Product = new Product(this.#productTemplate.cloneNode(true));
    product.slug = data.slug;
    product.image = data.image;
    product.title = data.title;
    product.rating = data.ratings;
    product.price = data.price;
    product.setEventData(data, this.dataLayerSuggestions.find((suggestion: Object) => suggestion.id === data.sku));
    product.ref = 'suggestion';

    if (data.priceMax !== data.price) {
      product.maxPrice = data.priceMax;
    } else {
      product.removeMaxPrice();
    }

    return product.get().outerHTML;
  }
}
